import urlApi from '../../router/urlApi'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
    theme: 'none',
    position: 'bottom-center',
    className: 'vuestic-toast',
    iconPack: 'fontawesome',
    duration: 5000
}

Vue.use(Toast, toastOptions)

export default {


    getDataAlunoByCPF (cpfAluno, callback) {
        Vue.http.get(urlApi + '/alunos/cpf/' + cpfAluno).then(function (response) {
            callback(response)
        }).catch(function(err){
            callback(err)
        })
    },

    getDataInstrutorByCPF (cpfInstrutor,idTurma, callback) {
        Vue.http.get(urlApi + '/instrutores/cpf/' + cpfInstrutor + '/' + idTurma).then(function (response) {
            callback(response)
        }).catch(function(err){
            callback(err)
        })
    },

    launchToast (icon, msg) {
        Vue.toasted.show(msg, {
                icon: icon,
                position: 'top-right',
                duration: 5000,
                fullWidth: false
            }
        )
    },

    sendSnapshot(data, callback){
        Vue.http.post(urlApi + '/presencas/reconhecimento', data).then(function (response) {
            callback(response)
        }).catch(function(err){
            console.log(err)
            callback(err)
        })
    },

    checkCpf(cpf){
        Vue.http.post(urlApi + '/cfc/cpf', {cpf: cpf}).then(function (response) {
            callback(response)
        }).catch(function(err){
            console.log(response)
            callback(response)
        })
    }
}